import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import ComposedTextField from './ComposedTextField';
import ClientProvider from './client';
export default createDemo(import.meta.url, ComposedTextField, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/text-fields/demos/composed/ComposedTextField.tsx",
    "fileName": "ComposedTextField.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport Box from '@mui/material/Box';\nimport FilledInput from '@mui/material/FilledInput';\nimport FormControl from '@mui/material/FormControl';\nimport FormHelperText from '@mui/material/FormHelperText';\nimport Input from '@mui/material/Input';\nimport InputLabel from '@mui/material/InputLabel';\nimport OutlinedInput from '@mui/material/OutlinedInput';\n\nexport default function ComposedTextField() {\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 1,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  const simpleId = React.useId();\n  const helperId = React.useId();\n  const disabledId = React.useId();\n  const errorId = React.useId();\n  const outlinedId = React.useId();\n  const filledId = React.useId();\n  return (\n    <Box\n      component=\"form\"\n      sx={{ '& > :not(style)': { m: 1 } }}\n      noValidate\n      autoComplete=\"off\"\n    >\n      <FormControl variant=\"standard\">\n        <InputLabel htmlFor={`${simpleId}-input`}>Name</InputLabel>\n        <Input id={`${simpleId}-input`} defaultValue=\"Composed TextField\" />\n      </FormControl>\n      <FormControl variant=\"standard\">\n        <InputLabel htmlFor={`${helperId}-input`}>Name</InputLabel>\n        <Input\n          id={`${helperId}-input`}\n          defaultValue=\"Composed TextField\"\n          aria-describedby={`${helperId}-helper-text`}\n        />\n        <FormHelperText id={`${helperId}-helper-text`}>\n          Some important helper text\n        </FormHelperText>\n      </FormControl>\n      <FormControl disabled variant=\"standard\">\n        <InputLabel htmlFor={`${disabledId}-input`}>Name</InputLabel>\n        <Input id={`${disabledId}-input`} defaultValue=\"Composed TextField\" />\n        <FormHelperText>Disabled</FormHelperText>\n      </FormControl>\n      <FormControl error variant=\"standard\">\n        <InputLabel htmlFor={`${errorId}-input`}>Name</InputLabel>\n        <Input\n          id={`${errorId}-input`}\n          defaultValue=\"Composed TextField\"\n          aria-describedby={`${errorId}-error-text`}\n        />\n        <FormHelperText id={`${errorId}-error-text`}>Error</FormHelperText>\n      </FormControl>\n      <FormControl>\n        <InputLabel htmlFor={`${outlinedId}-input`}>Name</InputLabel>\n        <OutlinedInput\n          id={`${outlinedId}-input`}\n          defaultValue=\"Composed TextField\"\n          label=\"Name\"\n        />\n      </FormControl>\n      <FormControl variant=\"filled\">\n        <InputLabel htmlFor={`${filledId}-input`}>Name</InputLabel>\n        <FilledInput id={`${filledId}-input`} defaultValue=\"Composed TextField\" />\n      </FormControl>\n    </Box>\n  );\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 67,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport Box from '@mui/material/Box';\nimport FilledInput from '@mui/material/FilledInput';\nimport FormControl from '@mui/material/FormControl';\nimport FormHelperText from '@mui/material/FormHelperText';\nimport Input from '@mui/material/Input';\nimport InputLabel from '@mui/material/InputLabel';\nimport OutlinedInput from '@mui/material/OutlinedInput';\n\nexport default function ComposedTextField() {\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 1
        },
        "  const simpleId = React.useId();\n  const helperId = React.useId();\n  const disabledId = React.useId();\n  const errorId = React.useId();\n  const outlinedId = React.useId();\n  const filledId = React.useId();\n  return (\n    <Box\n      component=\"form\"\n      sx={{ '& > :not(style)': { m: 1 } }}\n      noValidate\n      autoComplete=\"off\"\n    >\n      <FormControl variant=\"standard\">\n        <InputLabel htmlFor={`${simpleId}-input`}>Name</InputLabel>\n        <Input id={`${simpleId}-input`} defaultValue=\"Composed TextField\" />\n      </FormControl>\n      <FormControl variant=\"standard\">\n        <InputLabel htmlFor={`${helperId}-input`}>Name</InputLabel>\n        <Input\n          id={`${helperId}-input`}\n          defaultValue=\"Composed TextField\"\n          aria-describedby={`${helperId}-helper-text`}\n        />\n        <FormHelperText id={`${helperId}-helper-text`}>\n          Some important helper text\n        </FormHelperText>\n      </FormControl>\n      <FormControl disabled variant=\"standard\">\n        <InputLabel htmlFor={`${disabledId}-input`}>Name</InputLabel>\n        <Input id={`${disabledId}-input`} defaultValue=\"Composed TextField\" />\n        <FormHelperText>Disabled</FormHelperText>\n      </FormControl>\n      <FormControl error variant=\"standard\">\n        <InputLabel htmlFor={`${errorId}-input`}>Name</InputLabel>\n        <Input\n          id={`${errorId}-input`}\n          defaultValue=\"Composed TextField\"\n          aria-describedby={`${errorId}-error-text`}\n        />\n        <FormHelperText id={`${errorId}-error-text`}>Error</FormHelperText>\n      </FormControl>\n      <FormControl>\n        <InputLabel htmlFor={`${outlinedId}-input`}>Name</InputLabel>\n        <OutlinedInput\n          id={`${outlinedId}-input`}\n          defaultValue=\"Composed TextField\"\n          label=\"Name\"\n        />\n      </FormControl>\n      <FormControl variant=\"filled\">\n        <InputLabel htmlFor={`${filledId}-input`}>Name</InputLabel>\n        <FilledInput id={`${filledId}-input`} defaultValue=\"Composed TextField\" />\n      </FormControl>\n    </Box>\n  );\n"
      ],
      [
        "span",
        "frame",
        "}\n"
      ]
    ],
    "totalLines": 67,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/Box",
      "@mui/material/FilledInput",
      "@mui/material/FormControl",
      "@mui/material/FormHelperText",
      "@mui/material/Input",
      "@mui/material/InputLabel",
      "@mui/material/OutlinedInput"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
